import React, { FunctionComponent } from 'react';
import { InternalLink } from '../../internal-link/internal-link';
import { createSlug } from '../../../utils/utils';
import styles from './job-offert-item.module.scss';
import sanitizeHtml from 'sanitize-html';

export interface IJobOffertItemProps {
  title: string;
  jobLocation: string;
  buttonText?: string;
}

export const JobOffertItem: FunctionComponent<IJobOffertItemProps> = ({
  title,
  jobLocation,
  buttonText
}) => {
  const url = createSlug(title);
  return (
    <InternalLink url={`/job/${url}`}>
      <div className={styles.wrapper}>
        <div className={`${styles.overlay}`}>
          <div className={styles.textWrapper}>
            <div className={styles.postition}>
              <h1>
                <strong
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(title) }}
                ></strong>
              </h1>
            </div>
            <p className={styles.city}>{jobLocation}</p>
          </div>
        </div>
        <div className={styles.applyButton}>{buttonText}</div>
      </div>
    </InternalLink>
  );
};
